<div class="flex-column-center">
	<div class="row">
		<h3 i18n="property-aboutDialogSave">Save</h3>
		<div i18n="property-aboutDialogPropertyDetails">| Property Details</div>
	</div>
	<mat-divider></mat-divider>

	<mat-dialog-content>
		@if (showMessage) {
			<div class="padding-24" i18n="property-aboutDialogContentMessage">
				Are you sure you want to update this information?
			</div>
		}

		@if (showLoading) {
			<div class="padding-bottom-24 align-center div-flex-column">
				<mat-icon class="success-checkmark align-center margin-top" svgIcon="sl-spinner"></mat-icon>
				<div class="align-center" i18n="property-aboutDialogLoadingMessage">Updating Property Details...</div>
			</div>
		}

		@if (showError) {
			<div class="padding-24 align-center div-flex-column">
				<mat-icon class="failure-crossout align-center margin-top">close</mat-icon>
				<div class="align-center" i18n="property-aboutDialogErrorMessage">Error Updating Property Details...</div>
			</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions class="row-right">
		<button
			mat-button
			class="secondary-button"
			(click)="onCancelClicked()"
			i18n="property-aboutDialogCancel"
			data-automation-id="property-about-dialog-cancel-button"
		>
			Cancel
		</button>
		@if (showMessage) {
			<button
				mat-button
				class="primary-button"
				(click)="onConfirmClicked()"
				i18n="property-aboutDialogConfirm"
				data-automation-id="property-about-dialog-confirm-button"
			>
				Confirm
			</button>
		}
	</mat-dialog-actions>
</div>
